import React from 'react';
import arrowDownIcon from '../../assets/images/arrow-down-solid.svg';
import arrowUpIcon from '../../assets/images/arrow-up-solid.svg';

const SortIndicator = ({ sort }) => (
  <img alt='' className='inline-icon' src={sort === 'asc' ? arrowDownIcon : arrowUpIcon} />
);

export default SortIndicator;
